document.addEventListener("DOMContentLoaded", () => {

const cards = document.querySelectorAll(".fade-in");

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {

        if (entry.isIntersecting) {

            const index = [...cards].indexOf(entry.target);
            entry.target.style.animationDelay = `${index * 0.03}s`;

            entry.target.classList.add("visible");
            observer.unobserve(entry.target);

        }

    });

}, {rootMargin:"0px 0px 400px 0px"});

cards.forEach(card => observer.observe(card));

});

document.querySelectorAll('.qa-trigger').forEach((trigger) => {
  trigger.addEventListener('click', () => {
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    const answer = trigger.nextElementSibling;

    // Close all other items
    document.querySelectorAll('.qa-trigger').forEach((other) => {
      if (other !== trigger && other.getAttribute('aria-expanded') === 'true') {
        other.setAttribute('aria-expanded', 'false');
        other.nextElementSibling.classList.remove('open');
      }
    });

    // Toggle current item
    trigger.setAttribute('aria-expanded', !isOpen);
    answer.classList.toggle('open');
  });
});